import { Link } from "react-router-dom";
import { Lock, Sparkles, MessageCircle, Heart, BookOpen, Wind, Target, Leaf, PlayCircle, Headphones } from "lucide-react";
import { TYPE_META, mediaUrl } from "@/lib/api";

const ICONS = { parent_child: Heart, solo: Sparkles, prompt: MessageCircle, article: BookOpen, exercise: Target, breathwork: Wind, meditation: Leaf };

export default function ResourceCard({ r, compact }) {
  const Icon = ICONS[r.type] || Leaf;
  return (
    <Link to={`/r/${r.slug}`} data-testid={`resource-card-${r.slug}`}
      className="group card-bt flex h-full flex-col overflow-hidden transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(13,61,38,0.35)]">
      {!compact && (
        <div className="relative h-44 overflow-hidden bg-bt-sage">
          {r.image ? (
            <img src={mediaUrl(r.image)} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          ) : (
            <div className="flex h-full items-center justify-center">
              <svg viewBox="0 0 200 100" className="absolute h-40 w-80 text-bt-sagedeep opacity-25" fill="none">
                <path d="M100 50c-18-26-38-38-58-38C20 12 6 30 6 50s14 38 36 38c20 0 40-12 58-38zm0 0c18 26 38 38 58 38 22 0 36-18 36-38s-14-38-36-38c-20 0-40 12-58 38z" stroke="currentColor" strokeWidth="3" />
              </svg>
              <Icon className="relative text-bt-primary" size={34} strokeWidth={1.5} />
            </div>
          )}
          {r.access === "members" && (
            <span className="absolute right-4 top-4 inline-flex items-center gap-1 rounded-full bg-bt-primary px-3 py-1 text-xs font-semibold text-bt-bg">
              <Lock size={12} /> Members
            </span>
          )}
        </div>
      )}
      <div className="flex flex-1 flex-col p-6">
        <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-bt-sagedeep">
          {compact && <Icon size={14} />}
          <span>{TYPE_META[r.type] || r.type}</span>
          {r.access === "free" && <span className="rounded-full bg-bt-sage px-2 py-0.5 text-[10px] text-bt-primary">Free</span>}
          {compact && r.access === "members" && <Lock size={12} />}
        </div>
        <h3 className="text-xl leading-snug">{r.title}</h3>
        {!compact && <p className="mt-2 line-clamp-2 text-[15px] text-bt-text">{r.description}</p>}
        <div className="mt-auto flex items-center gap-3 pt-5 text-sm text-bt-sagedeep">
          {r.duration && <span>{r.duration}</span>}
          {r.video_url && <PlayCircle size={16} />}
          {r.audio_url && <Headphones size={16} />}
        </div>
      </div>
    </Link>
  );
}

export const ResourceGrid = ({ items, testid, compact }) => (
  <div className={`grid gap-5 sm:grid-cols-2 ${compact ? "" : "lg:grid-cols-3"}`} data-testid={testid}>
    {items.map((r) => <ResourceCard key={r.id} r={r} compact={compact} />)}
  </div>
);
